export const downloadFile = async (fileUrl: string, name: string, headers?: Record<string, string>) => {
	const r = await fetch(fileUrl, { headers });
	const blob = await r.blob();
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.download = name;
	link.href = url;
	link.click();
};
